import type React from 'react';
import SelectDropdown from '../../../common/components/select-dropdown/index.js';

export type SiteDropdownProps = {
  readonly selected?: string;
  readonly onChange: (value: string) => void;
  readonly sites: Array<{
    siteId: string;
    siteTitle: string;
  }>;
};

const SiteDropdown: React.FC<SiteDropdownProps> = ({ sites, selected, onChange }: SiteDropdownProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    onChange(e.target.value);
  };

  const options = sites.map((site) => ({
    value: site.siteId,
    label: site.siteTitle
  }));
  return <SelectDropdown onChange={handleChange} options={options} selected={selected} />;
};

export default SiteDropdown;
